import { useSelector } from "react-redux";

export const useIsRTL = () => useSelector((state: GlobalState) => state.configuration.isRTL);
